module.exports = __webpack_public_path__ + "static/wtewe-opengraph-25aba86ab04523999ca134816376cc38.jpg";